"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroConf = void 0;
const bonjourMod = require("bonjour");
const events_1 = require("events");
const os_1 = require("os");
let callbackId = 0;
const bonjour = (bonjourMod.default ||
    bonjourMod);
const bonjourToZeroConfService = (service) => ({
    domain: service.host,
    type: service.type,
    name: service.name,
    port: service.port,
    hostname: service.fqdn,
    ipv4Addresses: service.addresses,
    ipv6Addresses: service.addresses,
    txtRecord: service.txt,
});
class ZeroConf extends events_1.EventEmitter {
    constructor() {
        super();
        this._services = [];
        this._browsers = {};
        this._bonjour = bonjour();
    }
    getHostname() {
        return Promise.resolve({ hostname: os_1.hostname() });
    }
    register(request) {
        const { name, type, domain, port, props } = request;
        const service = this._bonjour.publish({
            name,
            type,
            host: domain,
            port,
            txt: props,
        });
        this._services.push(service);
        service.start();
        return Promise.resolve();
    }
    unregister(request) {
        return new Promise(resolve => {
            const serviceIdx = this._services.findIndex(service => service.name === request.name &&
                service.type === request.type &&
                service.fqdn == request.domain);
            if (serviceIdx > -1) {
                const service = this._services[serviceIdx];
                service.stop(() => resolve());
                this._services = [
                    ...this._services.slice(0, serviceIdx),
                    ...this._services.slice(serviceIdx + 1),
                ];
            }
            else {
                resolve();
            }
        });
    }
    stop() {
        return new Promise(resolve => {
            this._bonjour.unpublishAll(() => resolve());
        });
    }
    async watch(request, callback) {
        if (callback != null) {
            throw new Error(`You cannot use callback in electron. Please subscribe to discover events`);
        }
        return new Promise(resolve => {
            const search = request.type.split('.');
            const type = search[0].replace(/^_/, '');
            const protocol = search.length > 1 ? search[1].replace(/^_/, '') : 'tcp';
            const browser = this._bonjour.find({ type, protocol });
            const id = `${callbackId++}`;
            browser.on('up', service => this.emit('discover', {
                action: 'resolved',
                service: bonjourToZeroConfService(service),
            }));
            browser.on('down', service => this.emit('discover', {
                action: 'removed',
                service: bonjourToZeroConfService(service),
            }));
            this._browsers[id] = { request, browser };
            browser.services.forEach(service => {
                this.emit('discover', {
                    action: 'added',
                    service: bonjourToZeroConfService(service),
                });
            });
            browser.start();
            resolve(id);
        });
    }
    unwatch(request) {
        return new Promise(resolve => {
            const browserId = Object.keys(this._browsers).find(id => {
                const { domain, type } = this._browsers[id].request;
                return domain === request.domain && type === request.type;
            });
            if (browserId != null) {
                const { browser } = this._browsers[browserId];
                browser.stop();
                delete this._browsers[browserId];
            }
            resolve();
        });
    }
    close() {
        return Promise.resolve();
    }
}
exports.ZeroConf = ZeroConf;
//# sourceMappingURL=zeroconf.js.map